import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import * as authActions from 'Global/Stores/auth'
import * as selectors from './selectors'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    hasError: selectors.hasError(state),
    isPending: selectors.isPending(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    redirectToRoot: user => dispatch(push('/search')),
    signIn: (email, password) => dispatch(authActions.signIn(email, password)),
  })

  Enhancer.displayName = 'SignInModuleEnhancer'

  Enhancer.propTypes = {
    hasError: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    redirectToRoot: PropTypes.func.isRequired,
    signIn: PropTypes.func.isRequired,
    user: PropTypes.object,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
